import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Form from "src/components/Form"
import HeadingSubSectionHeader from "src/components/Heading/HeadingSubSectionHeader"

const ManualCodeEntry = ({
  handleSubmit,
  value,
  setValue,
  disabled = false,
}) => {
  return (
    <div className="flex flex-col space-y-2">
      <HeadingSubSectionHeader>
        No scanner or camera? Use manual code
      </HeadingSubSectionHeader>
      <p className="text-gray-600">
        Ask customer for the manual code displayed on their QR code page
      </p>
      <label htmlFor="dockwa-pay-manual-code-entry" className="sr-only">
        Manual Code
      </label>
      <div className="mt-2 flex w-full flex-row space-x-2">
        <Form.TextField
          id="dockwa-pay-manual-code-entry"
          placeholder="Enter code"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={disabled}
        />
        <Button variant="secondary" onClick={handleSubmit} disabled={disabled}>
          Submit
        </Button>
      </div>
    </div>
  )
}

ManualCodeEntry.propTypes = {
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default ManualCodeEntry
